import {
  FlatList,
  SafeAreaView,
  StyleSheet,
  Text,
  View,
  Image,
  TextInput,
} from "react-native";
import React from "react";
import { Transportdata } from "../../Constants/Data";
import AppColors from "../../Constants/AppColors";
import AppFonts from "../../Constants/AppFonts";
import AppImages from "../../Constants/AppImages";

const TransportInactive = () => {
  return (
    <SafeAreaView style={{ flex: 1 }}>
      <View style={{ marginHorizontal: 20 }}>
        <View
          style={{
            width: "100%",
            height: 40,
            backgroundColor: AppColors.white,
            marginVertical: 10,
            borderRadius: 10,
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <TextInput
            placeholder="Search transport manager"
            placeholderTextColor={AppColors.grey}
            style={{ left: 10 }}
          />
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Image
              source={AppImages.search}
              style={{ width: 18, height: 18, marginRight: 20 }}
            />
            <Image
              source={AppImages.Shareit}
              style={{ width: 24, height: 20 }}
            />
          </View>
        </View>
        <FlatList
        showsVerticalScrollIndicator={false}
          data={Transportdata}
          renderItem={({ item }) => (
            <View style={{}}>
              <View
                style={{
                  backgroundColor: AppColors.sandal,
                  width: "100%",
                  marginTop: 20,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginVertical: 10,
                    marginHorizontal: 10,
                  }}
                >
                  <View style={{ flexDirection: "row" }}>
                    <Image
                      source={item.img1}
                      style={{ height: 40, width: 40 }}
                    />
                    <View style={{ flexDirection: "column", marginLeft: 10 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          fontWeight: "400",
                          fontFamily: AppFonts.OverpassMedium,
                          color: AppColors.brown1,
                        }}
                      >
                        {item.H1}
                      </Text>
                      <Text
                        style={{
                          fontSize: 14,
                          fontWeight: "600",
                          fontFamily: AppFonts.OverpassBold,
                          color: AppColors.brown1,
                        }}
                      >
                        {item.H2}
                      </Text>
                    </View>
                  </View>
                  <Image
                    source={item.img2}
                    style={{ width: 3, height: 19, marginRight: 10 }}
                  />
                </View>
                <View
                  style={{
                    backgroundColor: AppColors.brown,
                    height: 1,
                    width: "100%",
                    marginBottom: 20,
                  }}
                ></View>

                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: "75%",
                    marginHorizontal: 10,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 12,
                      fontWeight: "400",
                      fontFamily: AppFonts.OverpassMedium,
                      color: AppColors.brown1,
                    }}
                  >
                    {item.H3}
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      fontWeight: "400",
                      fontFamily: AppFonts.OverpassMedium,
                      color: AppColors.brown1,
                    }}
                  >
                    {item.H4}
                  </Text>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: "74%",
                    marginBottom: 20,
                    marginHorizontal: 10,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 14,
                      fontWeight: "600",
                      fontFamily: AppFonts.OverpassBold,
                      color: AppColors.brown1,
                    }}
                  >
                    {item.H5}
                  </Text>
                  <Text
                    style={{
                      fontSize: 14,
                      fontWeight: "600",
                      fontFamily: AppFonts.OverpassBold,
                      color: AppColors.brown1,
                    }}
                  >
                    {item.H6}
                  </Text>
                </View>
              </View>
            </View>
          )}
        />
      </View>
    </SafeAreaView>
  );
};

export default TransportInactive;

const styles = StyleSheet.create({});
